import SignUpLayout from "../../../components/signup/layout";
import { useContext } from "react";
import AuthContext from "../../../components/auth-context";
import Selectline from "../../ngn-file/select-line";
import { useState } from "react";
import FileApi from "../../../api/file";
import PurchaseTicketApi from "../../../api/purchase-ticket";
import useAppNavigate from "../../../components/router/use-app-navigate";

export default function NgnSignUpSelectline() {
  const [number, setNumber] = useState("");
  const context = useContext(AuthContext);
  const navigate = useAppNavigate();

  function handleClick(productId: number, phone: string) {
    console.log("Selected number:", number);
    new FileApi(context)
      .post(40, phone ?? "", "", "", "Owner", "", "")
      .then(({ errorMessage, id }) => {
        if (!errorMessage) {
          context.setActiveFileId(id);
          new PurchaseTicketApi(context)
            .post(id, +productId, 2)
            .then((ticket) => {
              if (ticket.errorMessage) navigate(`/signup/ngn/purchase`);
              else {
                new PurchaseTicketApi(context)
                  .getAll()
                  .then(context.setTickets)
                  .catch(() => {});
                navigate(`/signup/ngn/payment/${ticket.id}`);
              }
            })
            .catch(() => navigate(`/signup/ngn/purchase`));
        }
      });
  }

  return (
    <SignUpLayout step={4} type={40} steps={[3, 4, 5]}>
      <Selectline onSelectLine={setNumber} handleClick={handleClick} />
    </SignUpLayout>
  );
}
